<div>
  <meg-chart *ngFor="let widget of widgets;" [widget]="widget" [audit]="audit" [auditForm]="auditForm" [auditFormSchema]="auditFormSchema"></meg-chart>
</div>
